import React, { Component } from 'react';
import {
    Button,
    Label,
    Input,
    FormGroup,
    Form,
    Alert,
    NavLink,
    Spinner
} from 'reactstrap';
import PropTypes from 'prop-types';
import './OAuthUserLogin.css';
import { Link } from "react-router-dom";
import _ from 'lodash';
import { sharedLabelsPath } from "../../../reducers/common/localization";
import TwoFALoginModal from './../login/twoFALoginModal/TwoFALoginModal.container';
import { OAUTH_ERRORS } from '../../../constants/constants';

class OAuthUserLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            isRejected: false
        };
    }

    componentWillMount() {
        this.props.onCheckRequestParams(this.props.location.search);
    }

    componentWillUnmount() {
        this.props.onUnmount()
    }

    render() {
        if (this.props.oauthLoading || this.props.userDataLoading) {
            return this.renderSpinner();
        }

        if (!_.isNil(this.props.redirectTo)) {
            // if backend send path to redirect
            window.location = this.props.redirectTo;
            return this.renderSpinner();
        }

        if (!_.isNil(this.props.oauthError)) {
            // special backend errors
            if (this.props.oauthError === OAUTH_ERRORS.SERVER_ERROR || this.props.oauthError === OAUTH_ERRORS.TEMPORARILY_UNAVAILABLE) {
                // redirect if 500 & 503
                window.location = this.props.locationParams.redirect_uri + `?error=${this.props.oauthError}&state=${this.props.locationParams.state}`;
                return this.renderSpinner();
            } else if (this.props.oauthError === OAUTH_ERRORS.INVALID_REQUEST) {
                // error message if 400
                return this.renderErrorAlert(_.get(this.props.translation, 'oauth.incorrect_request_params_label'));
            } else {
                return this.renderErrorAlert(_.get(this.props.translation, sharedLabelsPath.errors)[this.props.oauthError] || _.get(this.props.translation, sharedLabelsPath.defaultError));
            }
        }

        if (this.state.isRejected) {
            // redirect if ACCESS_DENIED
            window.location = this.props.locationParams.redirect_uri + `?error=${OAUTH_ERRORS.ACCESS_DENIED}&state=${this.props.locationParams.state}`;
            return this.renderSpinner();
        }

        return (
            <div className="oauth-login-container">
                {this.renderContent()}
            </div>
        );
    }

    renderContent = () => {
        if (!this.props.isAuthorised) {
            return (
                <div className="oauth-login-form">
                    <Alert color="warning">{_.get(this.props.translation, 'oauth.sign_in_label')}</Alert>
                    <Form onSubmit={this.onLogIn}>
                        <h4 className="text-center">{_.get(this.props.translation, 'oauth.label')}</h4>
                        <FormGroup>
                            <Label for="oauth-login-email">{_.get(this.props.translation, sharedLabelsPath.email_label)}</Label>
                            <Input type="email"
                                value={this.state.email}
                                onChange={this.handleEmailChange}
                                required
                                placeholder={_.get(this.props.translation, sharedLabelsPath.email_label)} />
                        </FormGroup>
                        <FormGroup>
                            <Label for="oauth-login-password">{_.get(this.props.translation, sharedLabelsPath.password_label)}</Label>
                            <Input type="password"
                                value={this.state.password}
                                onChange={this.handlePasswordChange}
                                required
                                placeholder={_.get(this.props.translation, sharedLabelsPath.password_label)} />
                        </FormGroup>
                        <Button type="submit" block className="olive-green-btn">{_.get(this.props.translation, 'login.login_button')}</Button>
                    </Form>
                    <div className="other-abilities-account-container">
                        <NavLink target="_blank" className="forgot-password-nav-link" tag={Link} to="/login/restore">
                            {_.get(this.props.translation, 'login.forgot_password_label')}
                        </NavLink>
                        <div className="create-new-account-container">
                            {_.get(this.props.translation, 'login.haven_t_account_label') + " "}
                            <NavLink target="_blank" className="forgot-password-nav-link" tag={Link} to="/account-creation">
                                {_.get(this.props.translation, 'login.create_it_now_label')}
                            </NavLink>
                        </div>
                    </div>
                    <Alert color="warning" className="fetching-label" hidden={!this.props.loginLoading || this.props.is2FARequired}>
                        {_.get(this.props.translation, sharedLabelsPath.fetching_message)}
                    </Alert>
                    <Alert color="danger" className="error-label" hidden={!this.props.loginError || this.props.is2FARequired}>
                        {_.get(this.props.translation, sharedLabelsPath.errors)[this.props.loginError] || _.get(this.props.translation, sharedLabelsPath.defaultError)}
                    </Alert>
                    <TwoFALoginModal onSubmit={this.onLogInWithVerification} />
                </div>
            )
        } else {
            let accessInfo = _.get(this.props.translation, 'oauth.access_info_label').split('{client_name}');
            return (
                <div className="oauth-access-form">
                    <Form onSubmit={this.onAccept}>
                        <h4 className="text-center">
                            {_.get(this.props.translation, 'oauth.logged_in_data_label')
                                .replace('{user_name}', this.props.userData.firstName + ' ' + this.props.userData.lastName)
                                .replace('{user_email}', this.props.userEmail)}
                        </h4>
                        <div className="oauth-access-info">
                            <span>{accessInfo[0]}</span>
                            <h5>{this.props.requestData ? this.props.requestData.client_name : null}</h5>
                            <span>{accessInfo[1]}</span>
                        </div>
                        <div className="oauth-access-control-container">
                            <Button color="secondary" onClick={this.onReject}>
                                {_.get(this.props.translation, 'oauth.reject_label')}
                            </Button>
                            <Button type="submit" className="olive-green-btn">
                                {_.get(this.props.translation, 'oauth.accept_label')}
                            </Button>
                        </div>
                    </Form>
                    <div className="use-another-account-container">
                        <Button color="link" onClick={this.props.onLogout}>{_.get(this.props.translation, 'oauth.use_another_account_label')}</Button>
                    </div>
                    <Alert color="warning" className="fetching-label" hidden={!this.props.oauthLoading}>
                        {_.get(this.props.translation, sharedLabelsPath.fetching_message)}
                    </Alert>
                </div>
            )
        }
    }

    renderErrorAlert = (text) => {
        return (
            <div className="oauth-error-container">
                <Alert color="danger">{text}</Alert>
            </div>
        );
    };

    renderSpinner = () => {
        return (
            <div className="loading-oauth-container">
                <Spinner color="secondary" title={_.get(this.props.translation, sharedLabelsPath.fetching_message)} />
            </div>
        );
    };

    handleEmailChange = (e) => {
        this.setState({ email: e.target.value });
    };

    handlePasswordChange = (e) => {
        this.setState({ password: e.target.value });
    };

    onLogIn = (e) => {
        e.preventDefault();

        let data = {
            'username': this.state.email,
            'password': this.state.password,
        }

        this.props.onLogIn(data);
    };

    onLogInWithVerification = (verificationCode) => {
        let data = {
            'username': this.state.email,
            'password': this.state.password,
            'totpcode': verificationCode
        }

        this.props.onLogIn(data);
    };

    onAccept = (e) => {
        e.preventDefault();

        let data = this.props.locationParams;
        data["scope"] = this.props.requestData.scope;
        data["state"] = this.props.requestData.state;

        this.props.onGiveAccess(data);
    }

    onReject = () => {
        this.setState({ isRejected: true });
    }
}

OAuthUserLogin.propTypes = {
    locationParams: PropTypes.object.isRequired,
    oauthError: PropTypes.string,
    oauthLoading: PropTypes.bool,
    requestData: PropTypes.object,
    redirectTo: PropTypes.string,
    isAuthorised: PropTypes.bool.isRequired,
    loginError: PropTypes.string,
    loginLoading: PropTypes.bool,
    userDataLoading: PropTypes.bool,
    is2FARequired: PropTypes.bool,
    userEmail: PropTypes.string,
    userData: PropTypes.object,
    translation: PropTypes.object.isRequired,
    onLogIn: PropTypes.func.isRequired,
    onUnmount: PropTypes.func.isRequired,
    onCheckRequestParams: PropTypes.func.isRequired,
    onGiveAccess: PropTypes.func.isRequired,
    onLogout: PropTypes.func.isRequired
};

export default OAuthUserLogin;



// WEBPACK FOOTER //
// ./src/components/accountManagement/oauthUserLogin/OAuthUserLogin.js